import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import LicenceTransferDetails from "./LicenceTransferDetails";
import LicenceTransferHeader from "./LicenceTransferHeader";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import FurtherInformation from "./FurtherInformation";
import Page500 from "../../../pages/auth/Page500";
import {
  loadLicenceTransferAsync,
  selectLicenceTransfer,
} from "../../../redux/slices/licenceTransfer";

const LicenceTransfer = () => {
  const [loading, setLoading] = useState(false);
  const [loadingLicenceTransferId, setLoadingLiceneActionId] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const licenceTransferSelector = useAppSelector(selectLicenceTransfer);

  const dispatch = useAppDispatch();

  let { profileNo, licenceTransferId } = useParams();
  if (!profileNo || !licenceTransferId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingLicenceTransferId !== licenceTransferId) {
    setLoadingLiceneActionId(licenceTransferId);
    dispatch(loadLicenceTransferAsync(licenceTransferId));
    return <Loading />;
  }

  const licenceTransferDetails = licenceTransferSelector.licenceTransfer;

  if (!licenceTransferDetails) {
    return <Loading />;
  }

  if (!licenceTransferDetails.response.ok) {
    if (licenceTransferDetails.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LicenceTransferHeader
            licenceTransferDetails={licenceTransferDetails}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LicenceTransferDetails
            licenceTransferDetails={licenceTransferDetails}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <FurtherInformation
            licenceTransferDetails={licenceTransferDetails}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        licenceTransferDetails={licenceTransferDetails}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="licence-versions"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default LicenceTransfer;
